import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Map of paths to page titles
const pageTitle = {
  '/': 'Dashboard | Off The Tree',
  '/dashboard': 'Dashboard | Off The Tree',
  '/login': 'Login | Off The Tree',
  '/create-password': 'Create Password | Off The Tree',
  '/reset-password': 'Reset Password | Off The Tree',
  '/forgot-password': 'Forgot Password | Off The Tree',
  '/manager': 'Managers | Off The Tree',
  '/employee': 'Employees | Off The Tree',
  '/staff-attendance': 'Staff Attendance | Off The Tree',
  '/attendance-report': 'Attendance Report | Off The Tree',
  '/employee-attendance': 'Employee Attendance | Off The Tree',
  '/employee-attendance-report': 'Employee Attendance Report | Off The Tree',
  '/employee-details': 'Employee Details | Off The Tree',
  '/supplier': 'Suppliers | Off The Tree',
  '/unloading': 'Unloading | Off The Tree',
  '/washing-area': 'Washing Area | Off The Tree',
  '/processing-washing': 'Processing Washing | Off The Tree',
  '/rework': 'Rework | Off The Tree',
  '/refrigeration': 'Refrigeration | Off The Tree',
  '/packing-washing': 'Packing Washing | Off The Tree',
  '/green-room': 'Green Room | Off The Tree',
  '/rejection': 'Rejection Log | Off The Tree',
  '/receiving-dashboard': 'Receiving Dashboard | Off The Tree',
  '/ripening-dashboard': 'Ripening Dashboard | Off The Tree',
  '/processing-dashboard': 'Processing Dashboard | Off The Tree',
  '/processing': 'Processing | Off The Tree',
  '/cooking': 'Cooking | Off The Tree',
  '/packing-dashboard': 'Packing Dashboard | Off The Tree',
  '/packing': 'Packing | Off The Tree',
  '/bagging': 'Bagging | Off The Tree',
  '/packing-sorting': 'Packing Sorting | Off The Tree',
  '/rework-dashboard': 'Rework Dashboard | Off The Tree',
  '/humid': 'Humid | Off The Tree',
  '/toasted': 'Toasted | Off The Tree',
  '/rework-refrigeration': 'Rework Refrigeration | Off The Tree',
  '/cold-storage': 'Cold Storage | Off The Tree',
  '/ripening-room': 'Ripening Room | Off The Tree',
  '/sorting': 'Sorting | Off The Tree',
  '/ripening-washing': 'Ripening Washing | Off The Tree',
  '/brokerage-dashboard': 'Brokerage Dashboard | Off The Tree',
  '/material-entered': 'Material Entered | Off The Tree',
  '/packing-and-sorting': 'Packing and Sorting | Off The Tree',
  '/brokerage-sorting': 'Brokerage Sorting | Off The Tree',
  '/brokerage-packing': 'Brokerage Packing | Off The Tree',
  '/brokerage-refrigeration': 'Brokerage Refrigeration | Off The Tree',
  '/refrigeration-area': 'Refrigeration Area | Off The Tree',
  '/bill-creation': 'Create Bill | Off The Tree',
  '/bill-listing': 'Bills | Off The Tree',
  '/bill-report': 'Billing Report | Off The Tree',
  '/gas-consumtion': 'Gas Consumption | Off The Tree',
  '/role-and-permission': 'Role & Permissions | Off The Tree',
  '/mixing': 'Mixing | Off The Tree',
  '/pasting': 'Pasting | Off The Tree',
  '/rework-packing': 'Rework Packing | Off The Tree',
  '/turn-2': 'Turn 2 | Off The Tree',

};

export const usePageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    // Get the title for the current path
    let title = pageTitle[location.pathname] || 'Off The Tree';

    // Handle dynamic routes like /bill-report/:id
    if (location.pathname.startsWith('/bill-report/')) {
      title = 'Bill Report | Off The Tree';
    }

    // Update the document title
    document.title = title;
  }, [location.pathname]);
};
